import styled from 'styled-components';

export const NotificationList = styled.div`
	padding-bottom: 1.5rem;
	overflow-y: auto;
`;

export const NoNotificationsMsg = styled.div`
	padding: 1rem;
`;

export const SpinnerContainer = styled.div`
	margin-bottom: 1.5rem;
	height: 4.5rem;
`;

export const LoadMoreContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1.5rem;
	padding: 1rem;
`;
